// removed by extract-text-webpack-plugin
module.exports = {"root":"root___3HqpR","wrap-container":"wrap-container___hmHT8","card-title":"card-title___2RNUK","card-url":"card-url___CzO4C"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/CheckQRCode/Index.less
// module id = qnP0
// module chunks = 12 13